export const getNextSortOrder = (
  sorterObj: any,
  tableParams: any,
  currentPage: number,
  lastSorterRef: React.MutableRefObject<any>
) => {
  let nextSort = sorterObj?.field || tableParams.sorter.field;
  let nextOrder: 'asc' | 'desc' | null = null;

  const lastSorter = lastSorterRef.current;
  const samePage = tableParams.pagination.current === currentPage;

  if (sorterObj && sorterObj.field) {
    const currentField = sorterObj.field;
    const currentOrder = sorterObj.order === 'ascend' ? 'asc' : sorterObj.order === 'descend' ? 'desc' : null;

    // Se clicou na mesma coluna na mesma página
    if (samePage && lastSorter?.field === currentField) {
      nextOrder = lastSorter.order === 'asc' ? 'desc' : 'asc';
    } else {
      nextOrder = currentOrder || 'asc';
    }

    lastSorterRef.current = { field: currentField, order: nextOrder };
  } else {
    // Nenhuma coluna clicada
    nextOrder = null;
    nextSort = null;
    lastSorterRef.current = null;
  }

  return { nextSort, nextOrder };
};